import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAward = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M12 2.682c-3.225 0-5.84 2.637-5.84 5.89 0 3.253 2.615 5.89 5.84 5.89 3.225 0 5.84-2.637 5.84-5.89 0-3.253-2.615-5.89-5.84-5.89Zm-8.003 5.89C3.997 4.114 7.58.5 12 .5s8.003 3.614 8.003 8.072c0 1.24-.278 2.416-.774 3.466l3.626 6.334c.2.349.193.78-.018 1.121-.21.342-.59.539-.988.513l-3.431-.223-1.524 3.11a1.08 1.08 0 0 1-1.906.062L12 17.733l-2.988 5.22a1.08 1.08 0 0 1-.971.544 1.081 1.081 0 0 1-.935-.607l-1.524-3.108-3.43.224a1.079 1.079 0 0 1-.99-.513 1.099 1.099 0 0 1-.017-1.12l3.626-6.336a8.098 8.098 0 0 1-.774-3.466Zm2.122 5.474-2.09 3.652 2.133-.139a1.08 1.08 0 0 1 1.04.605l.947 1.934 2.09-3.65a7.98 7.98 0 0 1-4.12-2.402Zm7.642 2.401a7.979 7.979 0 0 0 4.12-2.4l2.09 3.65-2.134-.138a1.08 1.08 0 0 0-1.039.605l-.947 1.934-2.09-3.65Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgAward);
export default ForwardRef;
